/**
 * Live clinic-OS labels. Keep in lockstep with api/src/clinic/labels.ts.
 * Titles match the product copy, not internal enum keys.
 */

export const ROLE_LABELS = {
  owner: 'Owner',
  manager: 'Manager',
  staff: 'Staff',
  medical_director: 'Medical Director',
} as const;

export const APP_ROLE_LABELS = {
  admin: 'Platform admin',
  user: 'User',
} as const;

export const CREDENTIAL_LABELS = {
  npiVerified: 'NPI',
  deaVerified: 'DEA',
  stateLicenseVerified: 'State license',
} as const;

export const CAPABILITY_LABELS = {
  create_location: 'Create locations',
  invite_owner: 'Invite owners',
  view_staff: 'View staff',
  view_locations: 'View locations',
} as const;

export const BOOKABLE_LABEL = 'Bookable';
export const NOT_BOOKABLE_LABEL = 'Not bookable';
